import React, { useState } from 'react';
import apiClient from '../../api/apiClient';
import type { RegistrationAbuseErrorPayload, EmailNotVerifiedErrorPayload } from '../../utils/authApiErrors';
import { isEmailNotVerifiedErrorPayload } from '../../utils/authApiErrors';

function ResendConfirmationLink({ email }: { email: string }) {
  const [status, setStatus] = useState<'idle' | 'sending' | 'sent' | 'error'>('idle');

  const handleResend = async (e: React.MouseEvent) => {
    e.preventDefault();
    setStatus('sending');
    try {
      await apiClient.post('/auth/resend-confirmation', { email });
      setStatus('sent');
    } catch {
      setStatus('error');
    }
  };

  if (status === 'sent') {
    return <span className="font-medium">Email sent. Check your inbox.</span>;
  }
  if (status === 'error') {
    return <span className="font-medium text-red-600">Couldn't send email. Try again later.</span>;
  }
  return (
    <button
      onClick={handleResend}
      disabled={status === 'sending'}
      className="font-medium text-primary underline hover:text-primary/80 disabled:opacity-60"
    >
      {status === 'sending' ? 'Sending…' : 'Resend confirmation email'}
    </button>
  );
}

export function authErrorToReactNode(
  error: string | RegistrationAbuseErrorPayload | EmailNotVerifiedErrorPayload | null | undefined
): React.ReactNode {
  if (error == null || error === '') {
    return '';
  }
  if (typeof error === 'string') {
    return error;
  }
  if (isEmailNotVerifiedErrorPayload(error)) {
    return (
      <>
        {error.message}{' '}
        <ResendConfirmationLink email={error.email} />
      </>
    );
  }
  return (
    <>
      {error.message}{' '}
      <a
        href={error.pricing_url}
        target="_blank"
        rel="noopener noreferrer"
        className="font-medium text-primary underline hover:text-primary/80"
      >
        webleads.site#pricing
      </a>
    </>
  );
}
